import { useParams } from 'react-router-dom'

import {
  EventsListFeedViewItemBox,
  EventStaticFieldIds,
} from '@tribeplatform/react-components/Event'
import { Link } from '@tribeplatform/react-components/Link'
import { useEvent } from '@tribeplatform/react-sdk/hooks'

import { withEmbedRouteChangeHandler } from '../withEmbedRouteChangeHandler.js'

export const EventEmbed = withEmbedRouteChangeHandler(() => {
  const params = useParams()
  const { id: eventId } = params
  const { data: event } = useEvent({
    variables: { id: eventId },
  })
  if (!event) {
    return null
  }

  return (
    <Link variant="inherit" href={event.relativeUrl}>
      <div className="relative w-full">
        <div className="w-full h-full absolute top-0 left-0 bg-transparent z-10" />
        <div className="not-prose bg-surface-subdued">
          <EventsListFeedViewItemBox
            event={event}
            visibleFieldIds={{
              [EventStaticFieldIds.CoverImage]: true,
              [EventStaticFieldIds.EventDetails]: true,
              [EventStaticFieldIds.HostInfo]: true,
            }}
          />
        </div>
      </div>
    </Link>
  )
})
